import { combineReducers } from 'redux';

import communicationsReducer from './communications.reducer';
import notificationsReducer from './notifications.reducer';
import provisionQualityReducer from './provisionQuality.reducer';
import provisionQualitySingleReducer from './provisionQualitySingle.reducer';
import connectionRunStatusReducer from '../connectionRunStatusPage/store/reducer';

export default combineReducers({
  communications: communicationsReducer,
  notifications: notificationsReducer,
  provisionQuality: provisionQualityReducer,
  connectionRunStatus: connectionRunStatusReducer,
  provisionQualitySingle: provisionQualitySingleReducer,
});
